"use client";

import Image from "next/image";

export interface LoaderProps {
  size?: number;
  message?: string;
}

export function Loader({
  size = 350,
  message = "Loading..."
}: LoaderProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f3f4f6",
      }}
    >
      {/* Pulsating logo with color animation */}
      <div
        style={{
          position: "relative",
          width: size,
          height: size * 0.5,
          animation: "logoColorPulse 2s ease-in-out infinite",
        }}
      >
        <Image
          src="/logo.svg"
          alt="Loading"
          fill
          style={{
            objectFit: "contain",
          }}
          priority
        />
      </div>

      {/* Loading message */}
      {message && (
        <p
          style={{
            marginTop: "0.75rem",
            fontSize: "1.125rem",
            fontWeight: 600,
            color: "#6d737a",
            animation: "pulse 2s ease-in-out infinite",
          }}
        >
          {message}
        </p>
      )}

      <style>{`
        @keyframes logoColorPulse {
          0%, 100% {
            filter: brightness(1) saturate(100%);
            transform: scale(1);
            opacity: 1;
          }
          50% {
            filter: brightness(0) saturate(100%) invert(44%) sepia(8%) saturate(629%) hue-rotate(169deg) brightness(93%) contrast(88%);
            transform: scale(1.05);
            opacity: 0.9;
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
}
